import apiUrl from '../../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import DatePicker from 'vue2-datepicker'
import CryptoJS from 'crypto-js'
import moment from 'moment'
import download from 'downloadjs'
import Loader from './../../shared/loader'
import Pagination from './../../shared/pagination'

import {
	Validator
} from 'vee-validate'

export default {
	name: 'ProductivityDockreceiptReport',
	components: {
	Pagination,
		DatePicker,
		download,
		Loader
	},

	data: function() {
		return {
			totalRows: 0,
			currentPage: 1,
			listRequestedReportData: [],
			listWarehouseData: [],
			listClientData: [],
			listRequestedreportNames: [],
			pageno: 0,
			limit: 10,
			pageCount: 0,
			isLoading: false,
			searchFlag: false,
			resultCount: '',
			clientid: '',
			clientarr: [],
			warehouseid: '',
			warehousearr: [],
			user_type: '',
			userid: '',
			reportname: '',
			transactionfromdate: moment().add(-30, 'days'),
			transactiontodate: moment(),
			api_url: apiUrl.api_url + 'downloadRequestedReport',
		}
	},

	created: function() {},

	filters: {
		capitalize: function(value) {
			if (!value) return ''
			value = value.toString()
			return value.charAt(0).toUpperCase() + value.slice(1)
		}
	},

	async mounted() {
		var permissionEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(permissionEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		var loginuserid = this.userid = userdetail.userid;
		this.user_type = userdetail.utype;
		switch (this.user_type) {
			case 'system_user':
				await this.getClientList();
				await this.getWarehouseList();
				break;

			case 'client_user':
				this.clientid = userdetail.clientid;
				await this.getWarehouseList();
				break;

			case 'warehouse_user':
				this.warehouseid = userdetail.warehouseid;
				await this.getClientList();
				break;

			default:
				this.$alertify.error(this.$t('common.unauthorisedError'));
				break
		}

		await this.getRequestedreportNames();
		await this.getRequestedreportData();
	},

	methods: {
		downloadZip(report, reportname) {
			var report = report;
			report += moment().format('DD-MM-YY HH:mm:ss') + '.zip';
			var reporturl = reportname;
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			this.isLoading = true;
			axios({
					method: 'GET',
					'url': apiUrl.api_url + 'downLoadFile?&reportname=' + reportname,
					responseType: 'blob',
					headers: {
						'Authorization': 'Bearer ' + myStr,
					},
					crossdomain: true,
				})
				.then(response => {
					if (response.data.size > 310 && response.data.type == "application/zip") {
						reportname = reportname.replace(/uploads|csv|/g, '');
						const url = window.URL.createObjectURL(new Blob([response.data]));
						const link = document.createElement('a');
						link.href = url;
						link.setAttribute('download', report); //or any other extension
						document.body.appendChild(link);
						link.click();
						this.Deletezipfile(reporturl);
						this.isLoading = false;
					} else if (response.data.size < 310 && response.data.type == "application/json") {
						this.$alertify.error(this.$t('reports.invalidFileErr'));
						this.isLoading = false;
						return false;
					}
				}, error => {
					console.error(error);
				});
		},
		Deletezipfile(reporturl) {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			this.input = ({
				reportpath: reporturl,
			});
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'deleteZipFile',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr,
					}
				})
				.then(result => {
					if (result.data.errorCode == 0) {
						this.resetForm();
					} else {
						this.$alertify.error(result.data.msg);
						return false;
					}
				}, error => {
					console.error(error);
				});
		},

		dateFormat(date) {
			if (!date) return '';
			return moment(date).format('YYYY-MM-DD');
		},

		dateFormatFRT(date) {
			if (!date) return '';
			//return moment(date).format('DD-MM-YYYY hh:mm');
			return moment(date).format('llll');
		},

		sizeFormat(filesize, filesizeunit) {
			if (filesize / 1024 < 1024) {
				filesize = filesize / 1024;
				return (filesize.toFixed(2) + ' KB');
			} else if (filesize / (1024 * 1024) < 1024) {
				filesize = filesize / (1024 * 1024);
				return (filesize.toFixed(2) + ' MB');
			} else if (filesize / (1024 * 1024 * 1024) < 1024) {
				filesize = filesize / (1024 * 1024 * 1024);
				return (filesize.toFixed(2) + ' GB');
			} else {
				return (filesize.toFixed(2) + ' ' + filesizeunit);
			}
		},

		getClientList() {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');

			this.input = ({
				warehouseid: this.warehouseid,
			});

			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getWarehouseAssociatedClientList',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr,
					}
				})
				.then(result => {
					this.listClientData = result.data.data;
					if (this.listClientData.length > 0) {
						for (let item in this.listClientData) {
							this.clientarr[this.listClientData[item].clientid] = this.listClientData[item].clientname;
						}
					} else {
						this.clientarr = [];
					}
				}, error => {
					console.error(error);
				});
		},

		getWarehouseList() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.pageno = 0;
			this.input = ({
				clientid: this.clientid,
			});
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					this.listWarehouseData = result.data.data;
					if (this.listWarehouseData.length > 0) {
						for (let item in this.listWarehouseData) {
							this.warehousearr[this.listWarehouseData[item].warehouseid] = this.listWarehouseData[item].warehousename;
						}
					} else {
						this.warehousearr = [];
					}

				}, error => {
					console.error(error);
				});
		},

		getRequestedreportNames() {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');

			axios({
					'method': 'GET',
					'url': apiUrl.api_url + 'getRequestedReportNames?u=' + this.userid,
					'headers': {
						'Authorization': 'Bearer ' + myStr,
					}
				})
				.then(result => {
					if (result.data.data.length > 0) {
						this.listRequestedreportNames = result.data.data;
					} else {
						this.listRequestedreportNames = [];
					}
				}, error => {
					console.error(error);
				});
		},

		getRequestedreportDataSearch() {
			this.pageno = 0;
			this.pageCount = 0;
			this.searchFlag = true;
			this.getRequestedreportData();
		},

		getRequestedreportData() {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			var drto_date = '';
			var drfr_date = '';

			this.isLoading = true;
			if (this.transactionfromdate) {
				drfr_date = this.dateFormat(this.transactionfromdate) + ' 00:00:00';
			}
			if (this.transactiontodate) {
				drto_date = this.dateFormat(this.transactiontodate) + ' 23:59:59';
			}
			this.input = ({
				offset: (this.currentPage - 1) * 10,
				limit: this.limit,
				fromdate: drfr_date,
				todate: drto_date,
				userid: this.userid,
				reportname: this.reportname,
				//clientid: this.clientid,
				//warehouseid: this.warehouseid
			})
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'requestedReportList',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then((result) => {
					this.isLoading=false
						this.listRequestedReportData = [];
						if(result.data.data!=''||result.data.data!=null){
						result.data.data.forEach((el) => {
							if (el.reportfileurl && el.reportfileurl != '' && el.reportfileurl != null) {
								let str = el.reportfileurl.slice(0, -4);
								let fileextension = str.split('.').pop()
								this.listRequestedReportData.push({
									id: el.id,
									clientid: el.clientid,
									warehouseid: el.warehouseid,
									userid: el.userid,
									reportname: el.reportname,
									reporttitle: el.reporttitle,
									reportfileurl: el.reportfileurl,
									status: el.status,
									filesize: el.filesize,
									filesizeunit: el.filesizeunit,
									createddate: el.createddate,
									modifieddate: el.modifieddate,
									details: el.details,
									fileextension: fileextension
								})
							} else {
								this.listRequestedReportData.push({
									id: el.id,
									clientid: el.clientid,
									warehouseid: el.warehouseid,
									userid: el.userid,
									reportname: el.reportname,
									reporttitle: el.reporttitle,
									reportfileurl: el.reportfileurl,
									status: el.status,
									filesize: el.filesize,
									filesizeunit: el.filesizeunit,
									createddate: el.createddate,
									modifieddate: el.modifieddate,
									details: el.details,
									fileextension: ""
								})
							}
						})
					}
						if (result.data.errorCode == -1) {
							this.resultCount = 0;
						} else {
							let totalRows = result.data.count;
							this.resultCount = result.data.count;
							console.log(totalRows,'totalRows');
							if (totalRows < this.limit) {
								this.pageCount = 1;
							} else {
								this.pageCount = Math.ceil(totalRows / this.limit);
							}
						}
						this.isLoading = false;
						console.log(this.pageCount);
					},
					error => {
						console.error(error)
					})
		},

		async resetForm() {
			this.reportname = '';
			// this.transactionfromdate = moment().add(-30, 'days');
			// this.transactiontodate = moment();
			this.transactionfromdate = '';
			this.transactiontodate = '';
			this.listRequestedReportData = [];
			this.pageno = this.pageCount = 0;
			this.searchFlag = false;
			await this.getRequestedreportData();
		},
		onPageChange(page) {
			this.currentPage = page;
			this.getRequestedreportData()
		},
		// getPaginationData(currentPage) {
		// 	this.pageno = (currentPage - 1) * this.limit;
		// 	this.getRequestedreportData();
		// },
	}
}



// WEBPACK FOOTER //
// ./src/views/components/reports/requestedreport/requestedreport.component.js